<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.user.order')}} </b-th>
            <b-th> {{$t('account.user.priorty')}} </b-th>
            <b-th> {{$t('account.user.type')}} </b-th>
            <b-th> {{$t('account.user.name')}} </b-th>
            <b-th> {{$t('account.user.task')}} </b-th>
            <b-th> {{$t('account.user.alarm')}} </b-th>
            <b-th> {{$t('account.user.operations')}} </b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="user in users" :key="user.id" v-b-popover.hover="popoverConfig(user)">
                <b-td> {{user.order_no}} </b-td>
                <b-td> {{user.priorty_no}} </b-td>
                <b-td> 
                    <template v-if="user.user_type == 1">
                        <b-badge variant="primary"> {{$t('account.panelUsers.user')}} </b-badge>
                    </template>
                    <template v-else-if="user.user_type == 2">
                        <b-badge variant="success"> {{$t('account.panelUsers.contact')}} </b-badge>
                    </template>
                    <template v-else-if="user.user_type == 0">
                        <b-badge variant="primary"> {{$t('account.panelUsers.user')}} </b-badge>
                        <b-badge variant="success"> {{$t('account.panelUsers.contact')}} </b-badge>
                    </template>
                    <b-badge v-if="isTemporary(user)" variant="warning"> {{$t('account.panelUsers.termUser')}} </b-badge>

                    
                </b-td>
                <b-td> {{user.name}} </b-td>
                <b-td> {{user.task.name}} </b-td>
                <b-td> 
                    <b-icon v-if="user.alarm_type == 0" icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.user.noAlarm')"> </b-icon> 
                    <p v-else-if="user.alarm_type == 1"> {{ $t('account.user.armAlarm') }} </p>
                    <p v-else-if="user.alarm_type == 2"> {{ $t('account.user.disarmAlarm') }} </p>
                    <p v-else-if="user.alarm_type == 3"> {{ $t('account.user.allAlarm') }} </p>
                </b-td>
                <b-td> 
                    <b-icon icon="files" variant="warning" scale="1.25" shift-v="1.25" aria-hidden="true" title="Kopyala" @click="openModal('SetState',{...user, type: 'usercopy'})"></b-icon>
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true" title="Düzenle" @click="openModal('edit',user)"></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" title="Sil" @click="openModal('delete', user)"></b-icon>
                </b-td>
            </b-tr>
          
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import moment from 'moment'
import jwt_decode from "jwt-decode";

    export default {
        name: "PanelUser",        
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function },
            Type: String
        },
        methods:{
            openModal:function(name, data){
                let form = ''
                if(this.getJWT.isLdapUser){
                    form = 'PanelUserLDAP'
                }else{
                    form = 'PanelUser'
                }
                this.modalType(true, form, 4)
                this.modalEvent(true, name, data)
            },
            isTemporary: function(user){
                if(moment((user.end_time).isValid || moment(user.begin_time).isValid ) && (!moment(user.begin_time).isBefore('2000-01-01', 'year') || !moment(user.end_time).isBefore('2000-01-01', 'year')))
                    return true
                else
                    return false
            },
            momentFormat: function(date){
               return moment(date).format('DD MMMM YYYY')
            },
             popoverConfig(data) {
                    return {
                        html: true,
                        placement: 'bottom',
                        customClass: 'popoverFluid',
                        content: () => {
                            let content = '<strong>'+i18n.t('account.user.registerNo')+': </strong> '+data.register_no+' <br />'
                            if(this.isTemporary(data)){
                                content += '<strong>'+i18n.t('account.note.beginDate')+': </strong>'+this.momentFormat(data.begin_time)+'<strong>'+i18n.t('account.note.endDate')+': </strong>'+this.momentFormat(data.end_time)+'<br />'
                            }
                            if(data.user_info){
                                for(let i = 0; i < data.user_info.length; i++){
                                    content += '<strong> '+i18n.t('account.user.email')+': </strong>'+data.user_info[i].email+'<strong> '+i18n.t('account.user.phone')+': </strong>'+data.user_info[i].phone_no+'<br />'
                                }
                            }
                           
                            return content
                        },
                    }
                },
        },
        computed: {
            getJWT(){
                return jwt_decode(localStorage.getItem('access_token'))
            },
            accountId(){
                return this.$store.getters.accountId
            },
            users(){
                return this.$store.getters.getAccountUsers
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/zone.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/PanelUsersForm.vue